<template>
    <div class="card">
        <div v-if="entrada.asiento" :class="'card-header bg-secondary ' + (entrada.asiento.region_name ? 'pt-2' : 'pt-0 pb-1')">
            {{ entrada.asiento.region_name ?? entrada.region_name }} <br/>
            <span v-if="entrada.asiento.row && entrada.asiento.seat">Fila: {{ entrada.asiento.row }} / Butaca: {{ entrada.asiento.seat }}</span>
            <span v-else>Sin numerar</span>
        </div>
        <div v-else-if="entrada.plaza" :class="'card-header bg-secondary ' + (entrada.plaza.region_name || entrada.plaza.sector_name ? 'pt-2' : 'pt-0 pb-3')">
            <span v-if="entrada.plaza.region_name">Zona: {{ entrada.plaza.region_name }} | </span>
            <span v-if="entrada.plaza.sector_name">Sector: {{ entrada.plaza.sector_name }}</span> <br/>
            <span>Fila: {{ entrada.plaza.fila }} | Butaca: {{ entrada.plaza.butaca }}</span>
            <span v-if="entrada.plaza.numero">Plaza: {{ entrada.entrada.numero }}</span>
        </div>
        <div v-else class="card-header bg-secondary">
            <span>Sin numerar</span>
        </div>
        <div class="card-body">
            <template v-if="evento.solicitar_datos">
                <b-row>
                    <b-col sm="12" md="12" class="mt-2">
                        <FormInput id="nombre" label="Nombre" name="Nombre" v-model="entrada.nombre" />
                    </b-col>
                    <b-col sm="12" md="12" class="mt-2">
                        <FormInput id="apellidos" label="Apellidos" name="Apellidos" v-model="entrada.apellidos" />
                    </b-col>
                    <b-col sm="12" md="12" class="mt-2">
                        <FormInput id="dni" label="DNI" name="DNI" v-model="entrada.dni" />
                    </b-col>
                </b-row>
            </template>
            <div class="form-group">
                <label for="precio">Precio</label>
                <ValidationProvider name="precio" rules="required" v-slot="{ errors }">
                    <select class="form-control" id="select-precio" v-model="entrada.entrada">
                        <template v-for="(precio, index) in entrada.precios">
                            <option v-if="!entrada.plaza?.butaca && !entrada.plaza?.numero" :key="index" :value="precio">{{ precio.descripcion }} / {{ getPrecio(precio) | formatear_precio }}</option>
                            <option v-else :key="index" :value="precio">{{ precio.descripcion }} / {{ getPrecio(precio) | formatear_precio }}</option>
                        </template>
                    </select>
                    <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs" style="width: 98%; display: block; background-color: red; color: white; padding: 2px;">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <div class="form-group" v-if="teatro.solicitar_genero_taquilla">
                <label for="genero">Género</label>
                <select class="form-control" id="select-genero" v-model="entrada.genero_id">
                    <template v-for="genero in generos">
                        <option :key="genero.id" :value="genero.id">{{ genero.name }}</option>
                    </template>
                </select>
            </div>
            <div class="form-group" v-if="permisos['venta.descuento']">
                <label for="descuento">Descuento</label>
                <select class="form-control" id="select-descuento" v-model="entrada.descuento">
                    <option value="0">Sin descuento</option>
                    <template v-for="(descuento, index) in configuracion.descuentos_disponibles">
                        <option :key="index" :value="descuento">{{ descuento }}%</option>
                    </template>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            entrada: {
                type: Object,
                required: true
            },
            evento: {
                type: Object,
                required: true
            }, 
            generos: {
                tyoe: Array,
                required: true
            },
            index: {
                type: Number,
                required: true
            }
        },
        methods: {
            getPrecio(precio) {
                let price = parseFloat(precio.precio);
            
                if(precio.price_management_interno) {
                    return price;
                }

                return price + parseFloat(precio.price_management);
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            permisos() {
                return this.$store.getters.getPermisos;
            }
        },
        created() {
            var hash_teatro = this.configuracion.hash_teatro;
            if(hash_teatro === 'jPrFr1rSNcqbXShv50cb' || hash_teatro === 'YPY8EVtyoYMWay0EHAmN' || hash_teatro === 'UmeRCe3vusTW1LYct845' || hash_teatro === 'j5ug7364MkZLf6y280dy') {
                var descuentos = [
                    'JÓVENES ENTRE 14 Y 25 AÑOS - 15',
                    'MAYORES DE 65 AÑOS - 15',
                    'DESEMPLEADOS - 15',
                    'FAMILIAS NUMEROSAS - 15',
                    'ESTUDIANTES CONSERVATORIO DANZA - 15',
                    'ESTUDIANTES CONSERVATORIO MÚSICA - 15',
                    'GRUPOS DE 15 O MÁS - 15',
                    'ESCUELA SUPERIOR ARTE DRAMÁTICO - 15',
                    'UNIVERSITARIOS - 15',
                    'MURCIA TOURIST CARD - 15',
                    'ERASMUS STUDENTS CARD - 15',
                    'ASOC. ACTORES DE LA REGIÓN DE MURCIA - 15',
                    'ASOC. PROFESIONALES CIRCO REGIÓN MURCIA - 15',
                    'ASOC.DRAMATURGOS REGIÓN MURCIA - 15',
                    'ASOCIACIÓN MURCIA ESCENA - 15',
                    'ASOC. DIRECTORES REGIÓN DE MURCIA - 15',
                    'ASOCIACIÓN PLATAFORMA 44 - 15',
                    'ASOCIACIÓN FATEAMUR - 15',
                    'UNIDADES FAMILIARES MONOPARENTALES - 15',
                ]

                this.configuracion.descuentos_disponibles = descuentos.concat(this.configuracion.descuentos_disponibles);
            }
        }
    }
</script>